import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { TxnStatusTableMaintainance, downloadTxnStatus } from "../../Services/api";
import instance from "../../redux/api";
import { CommonButton } from "../common/commonButton";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  TableContainer,
  Tooltip,
  Typography,
} from "@mui/material";
import DialogBox from "../common/dialog";
import {
  primaryButtonStyle,
  secondaryButtonStyle,
  downloadButtonStyle,
  updateButtonStyle,
  submitButtonStyle,
  primaryButtonHoverColor,
} from "../common/commonButtonStyles";
import "../common/commonPageStyles.css";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { AddTxnStatus } from "./AddTxnStatus";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ViewAndEditEntity } from "./ViewAndEditEntity";
import { CustomLoader } from '../CustomLoader';
import { commonToast } from "../common";
import EditIcon from "@mui/icons-material/Edit";
import format from "date-fns/format";

// #region Styles
const ResetSubmit = {
  justifyContent: "flex-end",
  paddingTop: "0px",
  marginRight: "12px",
};

const EditPageContainerTransactions = {
  padding: "10px",
  cursor: "default",
  width: "100%",
  marginLeft: "-10px",
};

const CloseIconStyle = {
  backgroundColor: "#3B3F44",
  color: "#ffff",
  height: "16px",
  width: "16px",
  padding: "7px 8px",
  borderRadius: "32px",
};

const dialogStyle = {
  maxWidth: "90vw",
  width: "90vw",
  margin: "auto",
};

// #endregion

export default function TxnStatusContainer() {
  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);
  const [row, setRow] = useState({ name: "" });
  const [tableRows, setTableRows] = useState([]);
  const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  const [txnStatusDialog, setTxnStatusDialog] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [isCreated, setIsCreated] = useState(true);
  const [validationStatus, setValidationStatus] = useState(true);
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  const [editRow, setEditRow] = useState("");
  const [editId, setEditId] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
    position: "relative",
  };

  const handleDialogClose = () => {
    setTxnStatusDialog(false);
    setEditMode(false);
    setViewMode(false);
    setValidationStatus(true);
    if (!editMode && !viewMode) {
      setRow(
        {
         name: ""
        },       
      );
    }
    else if (editMode) {
      setCurrentUpdatedFiledsInEditMode({});
    }
  };

  const handleActionButton = (rowData, isEditMode) => {
    const emptyRow = { name: "" };
    if (rowData && isEditMode) {
      setRow(rowData);
      setEditRow(rowData);
      setEditMode(true);
      setEditId(rowData.id);
      setIsCreated(false);
    } else if (rowData && !isEditMode) {
      setRow(rowData);
      setViewMode(true);
    } else {
      // If no rowDataForView is provided, it means we are in add mode
      setRow(emptyRow);
      setIsCreated(true);
      setTxnStatusDialog(true);
    }
    setTxnStatusDialog(true);
    if (rowData) {
      setIsCreated(false);
    } else {
      setIsCreated(true);
    }
  };

  const handleAddCancelled = () => {
    setOpen(false);
  };

  const handleAddConfirmed = async () => {
    setOpen(false);
    handleSubmit();
  };

  const handleReset = () => {
    const emptyRow = { name: "" };
    setRow(emptyRow);
    setValidationStatus(true);
  };

  const columns = [
    { 
      field: "id", 
      headerName: "Serial No",
      flex: 0.3, 
      headerAlign: "center",
      valueGetter: (params) => params.api.getRowIndex(params.row.id) + 1, // Added valueGetter to generate serial numbers
    },
    {
      field: "name",
      headerName: "Txn Status",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "created_by",
      headerName: "Created By",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-",
    },
    {
      field: "updated_by",
      headerName: "Last Modified By",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-",
    },
    ...(userData?.role !== "CC Processor"
      ? [
          {
            field: "actions",
            type: "actions",
            headerName: "Actions",
            flex: 0.8,
            cellClassName: "actions",
            getActions: ({ row }) => {
              let actionsList = [];
              if (UserAuthorisation?.['Edit'] === "Y") {
                actionsList.push(
                  <GridActionsCellItem
                    icon={
                      <Tooltip title="Edit">
                        {" "}
                        <EditIcon />{" "}
                      </Tooltip>
                    }
                    label="Edit"
                    className="textPrimary"
                    onClick={() => handleActionButton(row, true)}
                    color="inherit"
                  />
                );
              }                        
              if (UserAuthorisation?.["View"] === "Y") {
                actionsList.push(
                  <GridActionsCellItem
                    icon={
                      <Tooltip title="View">
                        <VisibilityIcon />
                      </Tooltip>
                    }
                    label="view"
                    className="textPrimary"
                    onClick={() => handleActionButton(row, false)}
                    color="inherit"
                  />
                );
              }
              return actionsList;
            },
          },
        ]
      : []),
  ];

  const loadData = async () => {
    try {
      setIsApiCallInprogress(true);
      const resp = await instance.get(TxnStatusTableMaintainance);
      console.log("resp", resp);
      setIsApiCallInprogress(false);
      if (resp.status === 200) {
        // const sortedData = resp.data.sort((a, b) => b.id - a.id);
        setTableRows(resp.data);
      } else {
        setTableRows([]);
      }
    } catch (err) {
      setIsApiCallInprogress(false);
      console.error("err", err);
    }
  };

  const UserAuthorisation =
    userData?.user_permissions?.permissions_list["Admin Table Maintenance"];

  useEffect(() => {
    console.log("useEffect");
    loadData();
  }, []);

  const handleInputChange = (colName, value) => {
    // Create a new object for the updated row
    const updatedRow = { ...row, [colName]: value };
    setRow(updatedRow);
    // Edit Mode
    if (editMode) {
      setCurrentUpdatedFiledsInEditMode({
        ...currentUpdatedFiledsInEditMode,
        [colName]: value,
      });
    }
  };

  const validateRow = (row) => {
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (!row || !row.name || row.name.trim() === "") {
      fieldValidations.name = "This field is required";
    }

    // Add more validations for other fields...
    setValidationStatus((prevStatus) => {
      const newStatus = { ...fieldValidations };
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;
  };

  const handleValidation = () => {
    // Validate each row before submission
    const isRowValid = validateRow(row);

    if (!isRowValid) {
      // If any row is invalid, stop the submission and display an error
      commonToast("error", "Please fill all required fields.");
      return;
    } else {
      setOpen(true);
    }
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    let editModeObj = {};
    if (editMode) {
      editModeObj.id = editRow?.id;
      editModeObj["updated_by"] = userData?.user_name ?? "";
      editModeObj = { ...editModeObj, ...currentUpdatedFiledsInEditMode };
    }
    try {
      let response;
      if (editMode) {
        response = await instance.patch(
          TxnStatusTableMaintainance + editId + "/",
          editModeObj
        );
        // clear preiously updated stored data
        setCurrentUpdatedFiledsInEditMode({});
      } else {
        const rowPaylaod = { ...row, created_by: userData?.user_name ?? "" };
        response = await instance.post(TxnStatusTableMaintainance, rowPaylaod);

      }
      if (response) {
        if (editMode) {
          commonToast("success", "Updated successfully !");
        } else {
          commonToast("success", "Submission successful !");

        }
        // clean up
        cleanupTransactionData();
      }
    } catch (err) {
      commonToast("error", "Submission failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const cleanupTransactionData = () => {
    handleDialogClose();
    loadData();
  };
  const handleDownloadBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${downloadTxnStatus}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `TransactionStatus_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Transaction Status data has been downloaded successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Transaction Status data could not be downloaded");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Transaction Status data could not be downloaded");
    }
  }

  return (
    <div style={Container}>
      {/* Main Content Area */}
      <Box className="main-content-area">
        <Box className="page-header-container">
          <Typography variant="h5" className="page-heading">
            Transaction Status Table
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {UserAuthorisation?.["Creation"] === "Y" && (
              <>
                <CommonButton
                  text="Add"
                  handleClick={() => handleActionButton()}
                  sx={primaryButtonStyle}
                  hoverColor={primaryButtonHoverColor}
                />
                <CommonButton
                  text="Export"
                  handleClick={handleDownloadBtnClick}
                  sx={downloadButtonStyle}
                  hoverColor={primaryButtonHoverColor}
                  disabled={isDownloadInProgress}
                />
              </>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            position: "relative",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            overflow: "hidden",
            transition: "all 0.3s ease",
            border: "1px solid #e8eaf0",
            width: "100%",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            },
          }}
        >
          <DataGrid
            loading={isApiCallInprogress}
            rows={tableRows}
            columns={columns}
            rowCount={tableRows?.length}
            keepNonExistentRowsSelected
            disableSelectionOnClick
            getRowId={(row) => row?.id}
            autoHeight={false}
            components={{
              Toolbar: () => null,
              NoRowsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  No Transaction Status Records
                </Stack>
              ),
            }}
            sx={{
              border: "none",
              flex: 1,
              minHeight: 0,
              width: "100%",
              "& .MuiDataGrid-root": {
                border: "none",
                height: "100%",
                width: "100%",
              },
              "& .MuiDataGrid-main": {
                height: "100%",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8f9fa",
                borderBottom: "2px solid #e0e0e0",
                minHeight: "52px !important",
                maxHeight: "52px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "transparent",
                fontWeight: "600",
                color: "#1672DE",
                fontSize: "14px",
                padding: "12px 16px",
                borderBottom: "none",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-row": {
                borderBottom: "1px solid #f0f0f0",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                },
                "&:nth-of-type(even)": {
                  backgroundColor: "#fafafa",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
                fontSize: "14px",
                color: "#333",
                padding: "12px 16px",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "1px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
              },
            }}
          />
        </Box>
      </Box>
      {/* <MyComponent /> */}
      <Dialog
        open={txnStatusDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={!viewMode && !editMode && { style: dialogStyle } || {}}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ cursor: "default", paddingBottom: "0px" }}
        >
          {viewMode ? "View Transaction Status" : editMode ? "Edit Transaction Status" : "Add Transaction Status"}
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            style={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon style={CloseIconStyle} />
          </IconButton>
          <hr style={{ width: "100%" }} />
        </DialogTitle>
        <DialogContent
          sx={{ overflowX: "hidden", padding: "0px 24px 5px 24px" }}
        >
          <div elevation={4} style={EditPageContainerTransactions}>
            {isCreated ? (
              <TableContainer style={{ maxHeight: "300px" }}>
                <AddTxnStatus
                  handleInputChange={handleInputChange}
                  row={row}
                  validationStatus={validationStatus}
                />
              </TableContainer>
            ) : (
              <>
                <Grid display={"flex"} flexDirection={"column"}>
                  <ViewAndEditEntity
                    row={row}
                    viewMode={viewMode}
                    validationStatus={validationStatus}
                    editMode={editMode}
                    handleInputChange={handleInputChange}
                  />
                </Grid>
              </>
            )}
          </div>
        </DialogContent>

        <DialogActions style={ResetSubmit}>
          {viewMode ? null : (
            <>
              {isCreated && (
                <CommonButton
                  sx={secondaryButtonStyle}
                  text="Reset"
                  handleClick={() => handleReset()}
                  disabled={editMode}
                />
              )}
              {editMode && (
                <CommonButton
                  sx={updateButtonStyle}
                  text="Update"
                  handleClick={handleSubmit}
                  disabled={
                    Object.keys(currentUpdatedFiledsInEditMode)?.length <= 0
                  }
                  hoverColor={primaryButtonHoverColor}
                />
              )}
              {!editMode && !viewMode && (
                <CommonButton
                  sx={submitButtonStyle}
                  text={isSubmitting ? <CustomLoader /> : "Submit"}
                  handleClick={() => handleValidation()}
                  hoverColor={primaryButtonHoverColor}
                  disabled={isSubmitting}
                />
              )}
            </>
          )}
        </DialogActions>
      </Dialog>

      <DialogBox
        title="Submit Confirmation"
        body="Are you sure you want to submit this record?"
        confirmText="Submit"
        isOpen={open}
        onCancel={handleAddCancelled}
        onConfirm={handleAddConfirmed}
      />
    </div>
  );
}